import * as React from 'react';
import {DragDropContext} from 'react-beautiful-dnd';

import type {SalesAutomationClosedLeadAutomation as SalesAutomationClosedLeadAutomationFragment} from 'nutshell-graphql-types';

import {ClosedLeadAccountAssignmentAutomation} from '../card-containers/closed-lead-account-assignment-automation';

import {CollapsibleSection} from './collapsible-section';

type Props = {
    closedLeadAutomations: SalesAutomationClosedLeadAutomationFragment[];
    isLoading: boolean;
    errorMessage: string | null | undefined;
};

export function ClosedLeadAccountTypeAutomations(props: Props) {
    return (
        <DragDropContext onDragEnd={() => {}}>
            <CollapsibleSection type='closedLeadAccountTypeAutomations'>
                <ClosedLeadAccountAssignmentAutomation
                    outcomeType='LEAD_WON'
                    isLoading={props.isLoading}
                    errorMessage={props.errorMessage}
                    closedLeadAutomations={props.closedLeadAutomations}
                />
                <ClosedLeadAccountAssignmentAutomation
                    outcomeType='LEAD_LOST'
                    isLoading={props.isLoading}
                    errorMessage={props.errorMessage}
                    closedLeadAutomations={props.closedLeadAutomations}
                />
                <ClosedLeadAccountAssignmentAutomation
                    outcomeType='LEAD_CANCELLED'
                    isLoading={props.isLoading}
                    errorMessage={props.errorMessage}
                    closedLeadAutomations={props.closedLeadAutomations}
                />
            </CollapsibleSection>
        </DragDropContext>
    );
}
